import { CircularProgress, SelectChangeEvent } from '@mui/material';
import { Catalog, SelectedItems } from '@src/pages/Catalogs';
import React, { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import LabeledTextField from '../CustomTextField/LabeledTextField';
import CustomSwitch from '../CustomSwitch/CustomSwitch';
import CustomDatePicker from '../CustomDatePicker/CustomDatePicker';
import LabeledSelectField from '../CustomSelect/LabeledSelectField';
import CustomButton from '../CustomButton/CustomButton';
import { convertUTCDateIntoIndianTimezone } from '@src/helpers/Helpers';
const AddContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: auto;
	gap: 15px;
`;

const GridContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const GridRow = styled.div`
	display: flex;
	gap: 20px;
`;

const GridItem = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	font-size: 16px;
	font-weight: 600;
	color: var(--color-font-grey);
`;

//For Mobile View
const StyledBottomBtnContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 68px;
	padding: 20px;
	background: var(--chat-header-bg);
	border: 1.5px solid var(--gray-color-light);
	z-index: 100;
	position: fixed;
	bottom: 0;
`;

const CatalogForm = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	width: 100%;
	padding: 20px;
	gap: 15px;
	@media screen and (max-width: 600px) {
		justify-content: center;
	}
`;
interface CatalogContainerProps {
	masterCatalog?: boolean;
	customers: any;
	loading: boolean;
	editCatalog: () => void;
	handleClose: () => void;
	disabledCatalog: () => boolean;
	draft: boolean;
	setDraft: (value: boolean) => void;
	catalogName: string;
	setCatalogName: (value: string) => void;
	effectToDate: Date | string | null;
	setEffectToDate: (date: Date | string | null) => void;
	effectFromDate: Date | string | null;
	setEffectFromDate: (date: Date | string | null) => void;
	customerId: string;
}
const CatalogContainer: React.FC<CatalogContainerProps> = ({
	masterCatalog = false,
	customers,
	loading,
	draft,
	setDraft,
	catalogName,
	setCatalogName,
	effectToDate,
	setEffectToDate,
	effectFromDate,
	setEffectFromDate,
	customerId,
	editCatalog,
	handleClose,
	disabledCatalog,
}) => {
	//Mobile Screen States
	const [windowDimensions, setWindowDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight,
	});

	const updateWindowDimensions = () => {
		setWindowDimensions({
			width: window.innerWidth,
			height: window.innerHeight,
		});
	};

	const catalogEditView = () => {
		if (windowDimensions?.width > 1100) {
			return (
				<>
					<div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', width: '100%' }}>
						<CustomButton
							title="Close"
							handleClick={handleClose}
							styles={{
								width: '150px',
								height: '36px',
								borderRadius: '4px',
								padding: '7px 47px 7px 47px',
								background: 'var(--btn-color-grey)',
								color: 'var(--default-text-color)',
								':hover': {
									background: 'var(--btn-hover-color) !important',
								},
							}}
						/>
						<CustomButton
							title={
								loading ? (
									<CircularProgress size={20} style={{ color: 'var(--default-text-color)' }} />
								) : (
									'Update Catalog'
								)
							}
							handleClick={editCatalog}
							heightVariant="medium"
							color="primary"
							styles={{
								width: '150px',
								height: '36px',
								padding: '7px 12px',
							}}
							disabled={disabledCatalog()}
						/>
					</div>
					<GridContainer>
						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
							<GridRow>
								<GridItem>
									<LabeledTextField
										label="Catalog Name"
										value={catalogName}
										onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
											setCatalogName(e?.target?.value as string)
										}
										placeholder="Catalog Name"
									/>
								</GridItem>

								<GridItem>
									<LabeledSelectField
										label="Customer Name"
										placeholder="Name"
										options={customers}
										value={customerId}
										handleChange={handleChange}
										disable
										styles={{ width: '344px', height: '36px' }}
									/>
								</GridItem>
							</GridRow>
							<CustomSwitch
								title={draft ? 'Publish' : 'Draft'}
								color="customGreen"
								checked={draft}
								onToggle={handleSwitchToggle}
							/>
						</div>
						<GridRow>
							<GridItem>
								<CustomDatePicker
									label="Effective From"
									styles={{ width: '344px', height: '36px' }}
									selectedDate={effectFromDate}
									onDateChange={(newDate) => handleEffectFromDate(newDate)}
								/>
							</GridItem>
							<GridItem>
								<CustomDatePicker
									label="Effective To"
									styles={{ width: '344px', height: '36px' }}
									minDate={effectFromDate}
									selectedDate={effectToDate}
									onDateChange={(newDate) => handleEffectToDate(newDate)}
								/>
							</GridItem>
						</GridRow>
					</GridContainer>
				</>
			);
		} else if (windowDimensions?.width > 600) {
			return (
				<>
					<div
						style={{
							display: 'flex',
							gap: '10px',
							justifyContent: 'center',
							width: '70vw',
							marginTop: '10px',
						}}
					>
						<CustomButton
							title="Close"
							handleClick={handleClose}
							styles={{
								width: '150px',
								height: '36px',
								borderRadius: '4px',
								padding: '7px 47px 7px 47px',
								background: 'var(--btn-color-grey)',
								color: 'var(--default-text-color)',
								':hover': {
									background: 'var(--btn-hover-color) !important',
								},
							}}
						/>
						<CustomButton
							title={
								loading ? (
									<CircularProgress size={20} style={{ color: 'var(--default-text-color)' }} />
								) : (
									'Update Catalog'
								)
							}
							handleClick={editCatalog}
							heightVariant="medium"
							color="primary"
							styles={{
								width: '150px',
								height: '36px',
								padding: '7px 12px',
							}}
							disabled={disabledCatalog()}
						/>
					</div>
					<CatalogForm>
						<LabeledTextField
							label="Catalog Name"
							value={catalogName}
							onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
								setCatalogName(e?.target?.value as string)
							}
							styles={{ width: '70vw', height: '36px' }}
							placeholder="Catalog Name"
						/>

						<LabeledSelectField
							label="Customer Name"
							placeholder="Name"
							options={customers}
							value={customerId}
							handleChange={handleChange}
							styles={{ width: '70vw', height: '36px' }}
						/>

						<CustomDatePicker
							label="Effective From"
							styles={{ width: '70vw', height: '36px' }}
							selectedDate={effectFromDate}
							onDateChange={handleEffectFromDate}
						/>
						<CustomDatePicker
							label="Effective To"
							styles={{ width: '70vw', height: '36px' }}
							minDate={effectFromDate}
							selectedDate={effectToDate}
							onDateChange={handleEffectToDate}
						/>
						<div style={{ display: 'flex', justifyContent: 'flex-start', width: '100%' }}>
							<CustomSwitch
								title={draft ? 'Publish' : 'Draft'}
								color="customGreen"
								checked={draft}
								onToggle={handleSwitchToggle}
							/>
						</div>
					</CatalogForm>
				</>
			);
		} else {
			return (
				<CatalogForm>
					<div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
						<CustomSwitch
							title={draft ? 'Publish' : 'Draft'}
							color="customGreen"
							checked={draft}
							onToggle={handleSwitchToggle}
						/>
					</div>
					<LabeledTextField
						label="Catalog Name"
						value={catalogName}
						onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
							setCatalogName(e?.target?.value as string)
						}
						styles={{ width: '328px', height: '36px' }}
						placeholder="Catalog Name"
					/>

					<LabeledSelectField
						label="Customer Name"
						placeholder="Name"
						options={customers}
						value={customerId}
						handleChange={handleChange}
						styles={{ width: '328px', height: '36px' }}
					/>

					<CustomDatePicker
						label="Effective From"
						styles={{ width: '328px', height: '36px' }}
						selectedDate={effectFromDate}
						onDateChange={handleEffectFromDate}
					/>
					<CustomDatePicker
						label="Effective To"
						styles={{ width: '328px', height: '36px' }}
						minDate={effectFromDate}
						selectedDate={effectToDate}
						onDateChange={handleEffectToDate}
					/>
				</CatalogForm>
			);
		}
	};

	const handleEffectToDate = (date: Date | null) => {
		setEffectToDate(convertUTCDateIntoIndianTimezone(date as Date));
	};

	const handleEffectFromDate = (date: Date | null) => {
		setEffectFromDate(convertUTCDateIntoIndianTimezone(date as Date));
	};

	const handleSwitchToggle = (newChecked: boolean) => {
		setDraft(newChecked);
	};
	const handleChange = (event: SelectChangeEvent<unknown>) => {
		const selectedValue = event.target.value as string;
	};

	//For Mobile Screen
	useEffect(() => {
		window.addEventListener('resize', updateWindowDimensions);

		return () => {
			window.removeEventListener('resize', updateWindowDimensions);
		};
	}, []);

	useEffect(() => {
		updateWindowDimensions();
	}, []);

	return <AddContainer>{catalogEditView()}</AddContainer>;
};

export default CatalogContainer;
